import { EditableContentController } from './EditableContentController';
import { EditableContentScope } from './models';

// Directive that wraps form elements adding a toolbar for saving and undoing form changes.
// Also contains any common form logic.  All validations are specified by the controller via
// the editMetadata directive property.  If the validation metadata does not specify a specific
// validation message, one is automatically generated based on the type of validation.  Also
// provides a base implementation for a wizard style of form editing.

export class EditableContentDirective implements angular.IDirective {
    public static $name: string = 'editableContent';
    public restrict: string = 'E';

    public bindToController: boolean = true;
    public controller = EditableContentController;
    public controllerAs: string = 'editableContentCtrl';

    // It is important that the directive has its own isolated scope.  This allows
    // there to be multiple directives of this type where each maintains the current
    // status of its associated form elements.

    // tslint:disable: object-literal-sort-keys
    public scope = {
        triggerSaveWithErrors: '<', // trigger save handler even when form is invalid
        canAlwaysSave: '=', // ignore $dirty checking if true
        currentStepMetadata: '=',  // The current step if being used to edit a series of related views.
        editMetadata: '=',  // Validation metadata provided by the controller.
        editViewModel: '=',  // View model for the editable content containing all the forms data.
        enableUndoOn: '@',  // Indicates the property on the view-model that should be copied to undo edits.

        cancelAction: '&?', // The bound method to call when the 'cancel' or 'x' buttons are clicked.
        saveAction: '&',  // The bound method to call when the form is saved.
        undoAction: '&',  // The bound method to call when changes are canceled.
        backAction: '&',  // If current step is specified, the bound method when user navigates back.

        subMenu: '=?',  // Menu items that are specific to the content being edited.
        editFormApi: '=',  // Binds object scope with methods that can be called by the controller.
        hideEditToolbarItems: '=',
        hideSaveNextButton: '=',
        disableSaveNextButton: '<?',
        isReady: '<?', // display a loading animation until this becomes true
        //                -- defaults to true to skip the loading animation, as most of these won't need loading
        toolbarClass: '@?',
        customAction: '&?', // custom action that does could be used inside this directive,
        customSaveLabel: '@?'
    };
    // tslint:enable: object-literal-sort-keys

    public template: string = require('!!html-loader!./EditableContent.html');

    public transclude: any = {
        form: 'editableContentForm',
        toolbar: 'editableContentToolbar'
    };

    public link = (
        scope: EditableContentScope,
        el: angular.IAugmentedJQuery,
        attrs: angular.IAttributes,
        controller: EditableContentController,
        transclude: angular.ITranscludeFunction
    ) => {
        transclude(scope, function (clone, scp) {
            clone.addClass('flex');
            clone.addClass('layout-row');
            el.find('.toolbar-content').append(clone);
        }, null, 'toolbar');

        transclude(scope, function (clone, scp) {
            clone.addClass('layout-fill');
            el.find('.md-inline-form').append(clone);
        }, null, 'form');

        el.addClass('layout-fill');
    }

    public static Factory() {
        const directive = () => {
            return new EditableContentDirective();
        };

        directive['$inject'] = [];

        return directive;
    }
}
